import * as React from 'react';
import { connect } from 'react-redux';

import DeliverableAttachmentUploader from 'modules/deliverables/components/deliverable-v2/deliverable-attachment-uploader/DeliverableAttachmentUploader';

import {
  updateAttachments
} from '../../redux/actions';

import { getTempNumericalId } from 'utils/id';

import {
  Deliverable,
  DeliverableAttachment,
  State
} from 'types';

interface OwnProps {
  deliverableId: number, // eslint-disable-line react/no-unused-prop-types
  snippetId: number, // eslint-disable-line react/no-unused-prop-types
  type: 'highres' | 'analytics'
}

interface StateProps {
  deliverable: Deliverable
}

interface DispatchProps {
  dispatchUpdateAttechments: (a: Array<DeliverableAttachment>) => void
}

type Props = OwnProps & StateProps & DispatchProps;

const StoryAttachmnetUploader = ({
  type,
  deliverable,
  dispatchUpdateAttechments
}: Props) => (
  <DeliverableAttachmentUploader
    isReplacement
    size="custom"
    deliverable={deliverable}
    attachmentType={type}
    onUpdate={dispatchUpdateAttechments}
  />
);

const mapStateToProps = (
  { storySnippets }: State,
  { deliverableId }: OwnProps
): StateProps => ({
  deliverable: storySnippets.deliverables[deliverableId]?.deliverable ?? {}
});

const mapDispatchToProps = (dispatch, {
  deliverableId,
  type,
  snippetId
}: OwnProps): DispatchProps => ({
  dispatchUpdateAttechments: attachments => dispatch(
    updateAttachments(
      deliverableId,
      snippetId,
      attachments.map(a => ({ ...a, id: getTempNumericalId() })),
      type
    )
  )
});

export default connect(mapStateToProps, mapDispatchToProps)(StoryAttachmnetUploader);
